import {SET_SIMULATION_LEVEL} from '../../Redux.constants';
import {setSimulationLevel} from './helper';

export function SimulationLevelReducer(state = {}, action) {
  switch (action.type) {
    case SET_SIMULATION_LEVEL:
      return setSimulationLevel(state, action.payload);
    default:
      return state;
  }
}
